import { render } from "./Trees.vue?vue&type=template&id=115f6256"
import script from "./Trees.vue?vue&type=script&lang=js"
export * from "./Trees.vue?vue&type=script&lang=js"

import "./Trees.vue?vue&type=style&index=0&id=115f6256&lang=css"
script.render = render

export default script